import React from 'react';

const Styled = ({args, key}) => {
  const text = args[0];
  const setStyle = args.length >= 2 ? args[1] : "strong";
  const style = require('./Styled.scss');
  let inlineStyle = {};
  if(setStyle.startsWith('#')) {
    inlineStyle.color = setStyle;
  }
  return (<span key={key} style={inlineStyle} className={style[setStyle] || style.default}>{text}</span>);
};

export default Styled;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Helpers/StyledText/StyledTextComponents/Styled.js
 **/